module.exports = __webpack_public_path__ + "fonts/DINNextLTPro-Bold.04d4871b.ttf";